import * as React from 'react'
import * as UI from '@/ui'

export type PProps = { children: React.ReactNode }
export const P = ({ children }: PProps) => (
  <UI.Paragraph size={{ default: 'medium', lg: 'large' }}>{children}</UI.Paragraph>
)
